import React from 'react'
import { withStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme';

type Props = {
  classes: {
    [K in string]: string
  },
  currentIndex: number,
  isAdvertShowing: boolean,
  numberOfDots: number,
  onClick?: ((arg0: number) => void)
}

const styles = (theme: Theme) => ({
  activeDot: {
    backgroundColor: theme.palette.common.black,
    cursor: 'auto'
  },
  advertSlideDots: {
    opacity: 0
  },
  dot: {
    backgroundColor: theme.palette.grey['300'],
    border: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    '&:not(:last-child)': {
      marginRight: theme.spacing(1)
    },
    height: 7,
    outline: 'none',
    padding: 0,
    width: 7
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  }
})

export function IndicatorDots (props: Props) {
  const { classes, currentIndex, numberOfDots, onClick, isAdvertShowing } = props
  const isAdvertShowingClass = isAdvertShowing ? classes.advertSlideDots : ''
  return (
    <div className={`${classes.root} ${isAdvertShowingClass}`} data-testid='indicator-dots-container'>
      {
        [...(Array(numberOfDots) as Array<void>)].map((_, index) => (
          <button
            data-testid='dot'
            key={index}
            className={`${classes.dot}${index === currentIndex ? ` ${classes.activeDot}` : ''}`}
            onClick={() => { if (onClick) onClick(index) }}
          />
        ))
      }
    </div>
  )
}

export default withStyles(styles,{defaultTheme: getDefaultTheme})(IndicatorDots)
